import { service } from "node-back-client/src/services/api";
import { sanitize } from "../util/sanitizeQuery";
let regionurl = process.env.VUE_APP_REGION_URL;

class AuditLogService {

    apiService

    constructor(url) {
        this.apiService = service(`${url}Controllers`
            , "AuditLog");
    }

    async getAuditLogs(server_id, filter = {}, skip = 0, limit = 10) {
        let sanitizedfilter = await sanitize.sanitizeQueryObject(filter)
        const auditLogs = await this.apiService.get(`Server/${server_id}?filter=${JSON.stringify(sanitizedfilter)}&skip=${skip}&limit=${limit}`);
        return auditLogs;
    }

    async getEquipmentName(equipmentId) {
        const response = await fetch(`${regionurl}/Equipments/${equipmentId}`);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data;
    }


}

export const auditlogservice = AuditLogService;
